module.exports = __webpack_public_path__ + "img/lianjie.decabd60.jpg";